export const ScaleObject : Phaser.Types.Core.ScaleConfig = {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    parent: 'thegame',
    // width: 800,
    // height: 640
    width: 1137,
    height: 640
}